<template>
  <transition name="fade" mode="out-in">
    <div class="InsightCharts InsightCharts--Loading" v-if="loading" style="position:relative; width:100%; min-height: 600px; display: flex; align-items: center; justify-content: center; font-family: 'Muli', sans-serif; z-index: 99999; opacity: 0.99">
      Processing data...
    </div>
    <Timeline v-else-if="graph === 'timeline'" :dataset="processedData" @filter="handleFilter" />
    <Status v-else-if="graph === 'status'" :dataset="processedData" @filter="handleFilter" />
    <Partners v-else-if="graph === 'partners'" :dataset="processedData" />
    <Services v-else-if="graph === 'services'" :dataset="processedData" />
  </transition>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4plugins_timeline from "@amcharts/amcharts4/plugins/timeline";

am4core.useTheme(am4themes_animated);

import Timeline from './components/Timeline'
import Status from './components/Status'
import Partners from './components/Partners'
import Services from './components/Services'

export default {
  name: "InsightCharts",
  components: {
    Timeline, Status, Partners, Services
  },
  props: {
    graph: {
      type: String,
      default: 'timeline',
      validator: function(value) {
        return [
          'timeline', 'services', 'partners', 'status'
        ].includes(value)
      }
    },
    data: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    processedData() {
      try {
        return JSON.parse(this.data)
      } catch(err) {
        return []
      }
    }
  },
  mounted() {
    // Yeah, we fake a loading state. This appears to actually improve the experience.
    // How? Showing the loading message provides instant feedback. Loading the graph 
    // takes time - enough to be noticeable. But why add the 300 ms forced delay? It 
    // gives the visitor time to read the message. About 50 - 500ms later the graph 
    // will appear, depending on the device processing capacity. This is well within 
    // 2s, and we take 300 ms to inform the visitor this is a "heavy" action.
    // Max speed is not always the best solution.
    setTimeout(() => this.loading = false, 300)
  },
  methods: {
    handleFilter({ ids }) {
      this.$emit("filter", { ids })
    }
  }
}
</script>